import { Controller } from "@hotwired/stimulus"
import { stimulus } from "../init"

// Flash/toast notifications rendered in layouts. Auto-dismisses after
// `timeoutValue` ms and removes itself when the close button is clicked.
export default class Flash extends Controller {
  static values = { timeout: { type: Number, default: 5000 } }

  connect() {
    this.timer = setTimeout(() => this.close(), this.timeoutValue)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  close() {
    if (this.timer) clearTimeout(this.timer)
    this.element.style.transition = "opacity 0.3s ease"
    this.element.style.opacity = "0"
    setTimeout(() => this.element.remove(), 300)
  }
}

stimulus.register("flash", Flash)
